export default __webpack_public_path__ + "static/media/about.90d451b1.jpg";